import { Routes } from '@angular/router';
import { AuthGuardPermission } from '../auth/auth.guard-permission';
import { TenantFeatureGuard } from '../tenant/tenant-feature.service';

const playerListLazy = () =>
  import('./player-list/player-list.component').then((m) => m.PlayerListComponent);
const playerCreateLazy = () =>
  import('./player-create/player-create.component').then((m) => m.PlayerCreateComponent);
const playerImportLazy = () =>
  import('./player-import/player-import.component').then((m) => m.PlayerImportComponent);
const playerMultiassignLazy = () =>
  import('./player-multiassign/player-multiassign.component').then((m) => m.PlayerMultiassignComponent);

/** Top-level player CMS routes (no `/player-content` prefix). */
export const playerSectionRoutes: Routes = [
  {
    path: 'team',
    children: [
      {
        path: ':teamId',
        children: [
          {
            path: 'roster',
            children: [
              { path: '', loadComponent: playerListLazy, canActivate: [TenantFeatureGuard], data: { tenantModule: 'players' } },
              {
                path: 'browse',
                loadComponent: playerMultiassignLazy,
                canActivate: [AuthGuardPermission, TenantFeatureGuard],
                data: { permission: 'teams.manage', tenantModule: 'teams' },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'players',
    redirectTo: '/my-dashboard/admin/users',
    pathMatch: 'full',
  },
  {
    path: 'add-player',
    children: [
      { path: '', loadComponent: playerCreateLazy, canActivate: [AuthGuardPermission, TenantFeatureGuard], data: { permission: 'users.manage', tenantModule: 'players' } },
      { path: 'team/:teamId', loadComponent: playerCreateLazy, canActivate: [AuthGuardPermission, TenantFeatureGuard], data: { permission: 'users.manage', tenantModule: 'players' } },
    ],
  },
  {
    path: 'multiassign-players',
    children: [
      {
        path: 'team/:teamId',
        redirectTo: '/team/:teamId/roster/browse',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'import-players',
    children: [
      { path: '', loadComponent: playerImportLazy, canActivate: [AuthGuardPermission, TenantFeatureGuard], data: { permission: 'users.manage', tenantModule: 'players' } },
      { path: 'team/:teamId', loadComponent: playerImportLazy, canActivate: [AuthGuardPermission, TenantFeatureGuard], data: { permission: 'users.manage', tenantModule: 'players' } },
    ],
  },
  {
    path: 'edit-player',
    redirectTo: '/my-dashboard/admin/users',
    pathMatch: 'full',
  },
  {
    path: 'edit-player/:playerId',
    redirectTo: '/my-dashboard/admin/users',
    pathMatch: 'full',
  },
  {
    path: 'edit-player/:playerId/team/:teamId',
    redirectTo: '/my-dashboard/admin/users',
    pathMatch: 'full',
  },
];
